const MUT = {
  SET_DATE_FROM_TO: 'SET_DATE_FROM_TO',
  SET_STATS_TIME_ORDER: 'SET_STATS_TIME_ORDER',
  SET_TYPES_WORKSHOP: 'SET_TYPES_WORKSHOP',
  SET_REST_POINTS: 'SET_REST_POINTS',
  SET_DELIVERY_TYPES: 'SET_DELIVERY_TYPES',
  SET_STATS_WORKSHOPS: 'SET_STATS_WORKSHOPS',
  SET_SELECTED_RESTPOINT: 'SET_SELECTED_RESTPOINT',
  SET_SELECTED_DELIVERY_TYPE: 'SET_SELECTED_DELIVERY_TYPE',
  SET_JWT_PARSED: 'SET_JWT_PARSED',
  SET_STATS_WORKER: 'SET_STATS_WORKER',
  SET_WORKERS: 'SET_WORKERS',
  SET_SELECTED_WORKER: 'SET_SELECTED_WORKER',
  SET_LOADING_STATE: 'SET_LOADING_STATE',
  SET_GROUP_BY_DAY: 'SET_GROUP_BY_DAY',
  SET_CONFIG_ROLLS_COUNT: 'SET_CONFIG_ROLLS_COUNT',
  SET_USER_STATUS: 'SET_USER_STATUS'
}

export const accountMUT = {
  SET_TOKEN: 'SET_TOKEN',
  SET_TOKEN_PARSED: 'SET_TOKEN_PARSED'
}

export const orderMUT = {
  SET_CURRENT_ORDER: 'SET_CURRENT_ORDER',
  SET_CLIENT: 'SET_CLIENT',
  SET_ORDER_TYPE_DISCOUNT: 'SET_ORDER_TYPE_DISCOUNT',
  SET_ORDER_SUM_DISCOUNT: 'SET_ORDER_SUM_DISCOUNT'
}

export const callCenterMUT = {
  SET_BRAND: 'SET_BRAND',
  SET_TAB_INDEX_BRAND: 'SET_TAB_INDEX_BRAND',
  SET_ORDER_DISCOUNT: 'SET_ORDER_DISCOUNT',
  SET_DISCOUNT_OPTIONS: 'SET_DISCOUNT_OPTIONS',
  SET_ORDER_ADDRESS: 'SET_ORDER_ADDRESS',
  SET_CONFIG_ORDER_HOLD_TIME: 'SET_CONFIG_ORDER_HOLD_TIME',
  SET_PRODUCT_IN_EDITING: 'SET_PRODUCT_IN_EDITING',
  SWITCH_MODAL_ADDITIONAL_PRODUCT: 'SWITCH_MODAL_ADDITIONAL_PRODUCT',
  SHOW_WARNING_MODAL: 'SHOW_WARNING_MODAL',
  SET_PREV_TYPE_DISCOUNT: 'SET_PREV_TYPE_DISCOUNT',
  SET_PREV_SUM_DISCOUNT: 'SET_PREV_SUM_DISCOUNT',
  HIDE_WARNING_MODAL: 'HIDE_WARNING_MODAL',
  BLOCK_DISCOUNT_VALUE_CHANGE: 'BLOCK_DISCOUNT_VALUE_CHANGE',
  SET_ORDER_PRODUCTS: 'SET_ORDER_PRODUCTS',
  SET_PROMOCODES: 'SET_PROMOCODES',
  SET_SELECTED_PROMOCODE: 'SET_SELECTED_PROMOCODE',
  SET_BLOCK_SUM: 'SET_BLOCK_SUM',
  SET_USE_PROMOCODE_SUM: 'SET_USE_PROMOCODE_SUM',
  ACTIVATE_PROMOCODE_GOOD: 'ACTIVATE_PROMOCODE_GOOD',
  DELETE_PROMOCODE_ITEM: 'DELETE_PROMOCODE_ITEM',
  SET_BRAND_ORIGIN_PRODS_MAP: 'SET_BRAND_ORIGIN_PRODS_MAP',
  ADD_PRODUCT_TO_ORDER: 'ADD_PRODUCT_TO_ORDER',
  SET_MAP_PRODUCTS: 'SET_MAP_PRODUCTS',
  SET_MAP_ADDITIONAL_PRODUCTS: 'SET_MAP_ADDITIONAL_PRODUCTS',
  SET_CONFIG_ORDERS_COUNT: 'SET_CONFIG_ORDERS_COUNT',
  SET_MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS: 'SET_MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS',
  SET_LAST_ID: 'SET_LAST_ID',
  SET_COURIER_AUTO_ASSIGN: 'SET_COURIER_AUTO_ASSIGN',
  SET_IS_REST_MANAGER: 'SET_IS_REST_MANAGER'
}

export const orderWorkshopMUT = {
  SET_STATS_WORKSHOPS_COOKED: 'SET_STATS_WORKSHOPS_COOKED',
  SET_LOADING_STATS_WORKSHOP_COOKED: 'SET_LOADING_STATS_WORKSHOP_COOKED'
}

export const orderTimeMUT = {
  SET_LOADING_STATS_ORDER_TIME: 'SET_LOADING_STATS_ORDER_TIME',
  SET_ORDER_TIME_STATS: 'SET_ORDER_TIME_STATS'
}

export const motivateAccountingMUT = {
  SET_WORKERS_ON_WORK_LIST: 'SET_WORKERS_ON_WORK_LIST'
}

export const overallWorkshopStatMUT = {
  SET_WORKERS_LIST: 'SET_WORKERS_LIST',
  ADD_WORKERS_STATS: 'ADD_WORKERS_STATS',
  SET_MIN_HOUR: 'SET_MIN_HOUR',
  SET_MOTIVATE_PERCENTS_LIST: 'SET_MOTIVATE_PERCENTS_LIST',
  SET_TOTAL_TURNOVER: 'SET_TOTAL_TURNOVER',
  SET_TOTAL_MOTIVATE_TURNOVER: 'SET_TOTAL_MOTIVATE_TURNOVER',
  SET_REQUESTED_DATE: 'SET_REQUESTED_DATE',
  CLEAR_WORKER_STATS: 'CLEAR_WORKER_STATS'
}

export const workshopsMUT = {
  SET_WORKSHOPS: 'SET_WORKSHOPS'
}

export const motivateMonitorWorkshopMUT = {
  setCookingTargetCurrentStats: 'setCookingTargetCurrentStats'
}

export default MUT



// WEBPACK FOOTER //
// ./src/constants/vuexMutations.js